export class Catalog {

    id : string = null;
    name : string = null;
    maintenance : number = null;
    repeat : boolean = null;

    getId(){
        return this.id;
    }

    setId(id: string){
        this.id = id;
    }

    getRepeat(){
        return this.repeat;
    }

    setRepeat(repeat: boolean){
        this.repeat = repeat;
    }

    getName(){
        return this.name;
    }

    setName(name: string){
        this.name = name;
    }

    getMaintenance(){
        return this.maintenance;
    }

    setMaintenance(maintenance: number){
        this.maintenance = maintenance;
    }

    reset(){
        this.id = null;
        this.name = null;
        this.maintenance = null;
        this.repeat = null;
    }
    
}